import React from 'react'
import { PageInfoHeader } from '../../comman/PageInfoHeader'

const ListingHeader = ({total, pagination, setPagination, count,  activeTab, setActiveTab, onTabChange,   branches = [],
  selectedBranch,
  setSelectedBranch,
  isBranchLocked = false }) => {

    return (
        <>
            <div className="row titlepad">
                <div className="col-md-12">
                    <div className="mt-3 mb-3">
                        <div className="dashbed-border-bottom"></div>
                    </div>

                    <div className="row">
                        <div className="col-sm-8">
                            <h4>My Orders</h4>
                            <p className="page-sub-head">
                                <PageInfoHeader
                                    page={pagination.page}           
                                    limit={pagination.limit}         
                                    total={total || 0}              
                                    label="List of Orders"
                                />
                            </p>
                            {/* <a
                                href="#"
                                data-toggle="modal"
                                data-target="#filter"
                                className="btn-md btn-primary d-inline-block"
                            >
                                <i className="iconly-boldFilter-2"></i> Filter
                            </a>
                            <a
                                href="#"
                                data-toggle="modal"
                                data-target="#search"
                                className="btn-md btn-dark d-inline-block"
                            >
                                <i className="iconly-boldSearch"></i> Search
                            </a> */}
                        </div>
                        {/* <div className="col-md-4 d-flex justify-content-end">
                            <div className="form-group" style={{ minWidth: "240px" }}>
                                <label>Select branch</label>
                                <select
                                    className="form-control"
                                    value={selectedBranch}
                                    onChange={(e) => setSelectedBranch(e.target.value)}
                                    >
                                    <option value="" disabled>
                                        Select Branch
                                    </option>

                                    {branches.map((branch) => (
                                        <option key={branch?.id} value={branch?.id}>
                                            {branch.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>
            <ul className="nav nav-tabs customer-tab-profile">
                  {/* <li className="nav-item profileLink" style={{cursor : "pointer"}}>
                    <a
                        className={`nav-link opacityCustomerTab opacityTab ${activeTab === "upcoming" ? "active" : ""}`}
                        onClick={() => setActiveTab("upcoming")}
                    >
                        <i className="fa fa-flask"></i>({count?.upcoming}) Upcoming
                    </a>
                </li> */}
                <li className="nav-item profileLink" style={{cursor : "pointer"}}>
                    <a
                        className={`nav-link opacityCustomerTab opacityTab ${activeTab === "totalOrders" ? "active" : ""}`}
                        onClick={() => onTabChange("totalOrders")}
                    >
                        <i className="fa-solid fa-folder-open"></i>({count?.totalOrders || 0}) Total Orders
                    </a>
                </li>

                <li className="nav-item profileLink" style={{cursor : "pointer"}}>
                    <a
                        className={`nav-link opacityCustomerTab opacityTab ${activeTab === "todayOrders" ? "active" : ""}`}
                        onClick={() => onTabChange("todayOrders")}
                    >
                        <i className="fa fa-calendar"></i>({count?.todayOrders || 0}) Today's Orders
                    </a>
                </li>

                <li className="nav-item profileLink" style={{cursor : "pointer"}}>
                    <a
                        className={`nav-link opacityCustomerTab opacityTab ${activeTab === "upcomingOrders" ? "active" : ""}`}
                        onClick={() => onTabChange("upcomingOrders")}
                    >
                        <i className="fa fa-calendar"></i>({count?.upcomingOrders || 0}) Upcoming Orders
                    </a>
                </li>

                <li className="nav-item profileLink" style={{cursor : "pointer"}}>
                    <a
                        className={`nav-link opacityCustomerTab opacityTab ${activeTab === "inProgressOrders" ? "active" : ""}`}
                        onClick={() => onTabChange("inProgressOrders")}
                    >
                        <i className="fa-solid fa-folder-open"></i>({count?.inProgressOrders || 0}) In Progress
                    </a>
                </li>

                 <li className="nav-item profileLink" style={{cursor : "pointer"}}>
                    <a
                        className={`nav-link opacityCustomerTab opacityTab ${activeTab === "cancelledOrders" ? "active" : ""}`}
                        onClick={() => onTabChange("cancelledOrders")}
                    >
                        <i className="fa-solid fa-circle-xmark"></i>({count?.cancelledOrders || 0}) Cancelled
                    </a>
                </li>



                <li className="nav-item profileLink" style={{cursor : "pointer"}}>
                    <a
                        className={`nav-link opacityCustomerTab opacityTab ${activeTab === "completedOrders" ? "active" : ""}`}
                        onClick={() => onTabChange("completedOrders")}
                    >
                        <i className="fa-solid fa-folder-open"></i>({count?.completedOrders || 0}) Completed
                    </a>
                </li>

                {/* <li className="nav-item profileLink" style={{cursor : "pointer"}}>
                    <a
                        className={`nav-link opacityCustomerTab opacityTab ${activeTab === "pending" ? "active" : ""}`}
                        onClick={() => onTabChange("pending")}
                    >
                        <i className="fa-solid fa-folder-open"></i>({count?.pending}) Pending
                    </a>
                </li> */}
                
            </ul>

        </>
    )
}

export default ListingHeader